<template>
  <div :style="themeStyle">
    <v-row no-gutters>
      <v-col>
        <span
          style="position: absolute; top: 15px; right: 20px; z-index: 10"
          class="bold"
        >
          <v-chip class="ma-2" color="#dddddd" style="font-size:12px">
            {{ level.name }}
          </v-chip>
        </span>
        <div
          class="pa-3"
          :style="
            'background-image: linear-gradient(291deg,' +
              $bgColorL3MG +
              '0%,' +
              $bgColorL3MG +
              '100%)'
          "
        >
          <v-fade-transition mode="out-in">
            <v-img :src="level.pictureUrl" max-height="220">
              <div class="back-forward pe-2"  @click="$router.push('/Card')">
               <div>
                <v-icon>mdi-chevron-left</v-icon> ย้อนกลับ
               </div>
              </div>

              <div
                style="
                 position: absolute;
                 bottom: 110px;
                 left: 20px;
                 display: flex;
                 align-items: center;
               "
              >
                <p
                  style="
                   font-weight: bold;
                   font-size: 24px;
                   margin-bottom: 10px;
                   color: white;
                 "
                  v-if="nextlevel"
                >
                  {{ formatNumber(member.collectPoint) }}/
                </p>
                <p
                  style="
                   font-weight: bold;
                   font-size: 24px;
                   margin-bottom: 10px;
                   color: white;
                 "
                  v-if="!nextlevel"
                >
                  {{ formatNumber(member.collectPoint) }}
                </p>
                <p
                  v-if="nextlevel !== null"
                  style="
                   font-weight: bold;
                   margin-bottom: 10px;
                   color: #871b12ff;
                   padding-top: 8px;
                   color: white;
                 "
                >
                  {{ formatNumber(point) }}
                </p>
                <img
                  v-if="profile.pictureUrl && !isTargetShop"
                  style="
                   border-color: white;
                   height: 30px;
                   margin-left:5px;
                   padding-bottom: 9px;
                 "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <img
                v-else
                class="ps-1"
                style="
                  border-color: white;
                  height: 20px;
                  margin-right: 4px;
                "
                alt="Avatar"
                :src="require('@/assets/DimondWhite.svg')"
              />
                <p
                  style="
                   position: absolute;
                   width: 300px;
                   bottom: -35px;
                   text-align: left;
                   color: #871b12ff;
                   font-size: 13px;
                   color: white;
                 "
                  v-if="!nextlevel"
                >
                  {{ $t("message.memberHightLevel") }}
                </p>
                <p
                  style="
                   position: absolute;
                   width: 300px;
                   bottom: -35px;
                   text-align: left;
                   color: #871b12ff;
                   font-size: 13px;
                   color: white;
                 "
                  v-if="nextlevel"
                >
                  {{ $t("message.collectMore") }}
                  {{ formatNumber(point - member.collectPoint) }}
                  {{ $t("message.point") }}
                </p>
                <p
                  style="
                   position: absolute;
                   width: 300px;
                   bottom: -50px;
                   text-align: left;
                   color: #871b12ff;
                   font-size: 13px;
                   color: white;
                 "
                  v-if="nextlevel"
                >
                  {{ $t("message.levelUp") }} {{ nextlevel.name }}
                </p>
              </div>
              <div class="test">
                <v-progress-linear
                  style="position: absolute; bottom: 110px"
                  height="5"
                  rounded
                  background-color="#EEEEEE"
                  color="green"
                  :value="valueInprogress"
                >
                </v-progress-linear>
              </div>
            </v-img>
          </v-fade-transition>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MenuItem from '../../MenuItem'
import MyRewards from '../../MyRewards'
import moment from 'moment'
import Dialog from './../Expiredialog'
import Dialog1 from './../Expiredialog1'
import axios from 'axios'
import EnglishMunMun from './../EnglishMunMun'

export default {
  name: 'Card',
  components: {
    'menu-item': MenuItem,
    'my-rewards': MyRewards,
    Dialog,
    Dialog1,
    EnglishMunMun
  },
  data () {
    return {
      myPackageCount: 0,
      allBookings: null,
      noDataMessage: null,
      allDataLoaded: false,
      checkTerm1: null,
      checkTerm2: null,
      dialog: false,
      member: null,
      level: null,
      rewards: null,
      nextlevel: null,
      valueInprogress: null,
      point: 0,
      dialogRewardhistory: false,
      expire: null,
      expire1: null,
      AllExpireCoinThisYear: null,
      AllExpireCoinNextYear: null,
      myPackage: false,
      month: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      month1: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      profile: null,
      shopId: null,
      shopname: null,
      rewardHistory: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.shopId = this.GET_SHOPID()
    this.profile = this.getLiffProfile()
    if (this.$route.query.shopId) {
      if (typeof this.$session.getAll().shopId === 'undefined') {
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    }
    if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
      this.getBookingView()
    }
    await this.prepareData()
    await this.getExpireDate()
    await this.getPackLog()
    if (this.$route.query.openHistory) {
      await this.getHistory()
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    ...mapActions('memberStore', ['getMemberProfile']),

    async getBookingView () {
      try {
        const response = await axios.get(`${this.DNS_Link}/booking_view/get`, {
          params: {
            shopId: this.shopId,
            userId: this.profile.userId
          }
        })

        if (!response.data) {
          throw new Error('No response data')
        }

        if (!Array.isArray(response.data)) {
          this.noDataMessage = response.data.message || 'No data available'
          this.allDataLoaded = true
          return
        }

        const bookings = response.data
        const statusMapping = {
          confirm: { status: 'ยืนยัน', color: '#4CAF50' },
          // eslint-disable-next-line camelcase
          confirmJob: RECORD_STATUS_Job => {
            // eslint-disable-next-line camelcase
            if (RECORD_STATUS_Job === 'N') {
              return { status: 'ยังไม่ปิดงาน', color: '#2196F3' }
              // eslint-disable-next-line camelcase
            } else {
              return { status: 'จบงาน', color: '#3F51B5' }
            }
          },
          cancel: { status: 'ยกเลิก', color: '#F44336' },
          default: { status: 'รอยืนยัน', color: '#FFB74D' }
        }

        const newBookings = bookings.map(item => {
          const {
            statusBt,
            // eslint-disable-next-line camelcase
            RECORD_STATUS_Job,
            flowName,
            dueDateTextDay,
            timeText,
            masBranchName,
            bookingDataCustomerName,
            bookingDataCustomerTel,
            remark,
            depositImge,
            hangoutLink
          } = item
          // const { status, color } = statusMapping[statusBt] || statusMapping.default
          let status, color
          if (statusBt === 'confirmJob') {
            ({ status, color } = statusMapping.confirmJob(RECORD_STATUS_Job))
          } else {
            ({ status, color } =
              statusMapping[statusBt] || statusMapping.default)
          }
          // console.log(item)
          return {
            status,
            color,
            title: flowName,
            day: this.convertDate(dueDateTextDay),
            time: timeText,
            branch: masBranchName,
            name: bookingDataCustomerName,
            phone: bookingDataCustomerTel,
            note: remark,
            linkMeet: hangoutLink,
            link: depositImge
          }
        })

        this.allBookings = newBookings
        this.displayedBookings = this.allBookings.slice(
          0,
          this.currentPage * this.itemsPerPage
        )

        if (newBookings.length < this.itemsPerPage) {
          this.allDataLoaded = true
        }
      } catch (error) {
        console.error('Error fetching booking view:', error.message)
      }
    },
    convertDate (dateString) {
      const buddhistYearFormat = 'DD MMM YYYY'
      const date = moment(dateString, 'DD/MM/YYYY').locale('th')
      return date
        .format(buddhistYearFormat)
        .replace(/(\d{4})/, match => parseInt(match) + 543)
    },
    async prepareData () {
      this.member = this.GET_MEMBERINFO()

      this.checkTerm1 = this.member.CONDITION_TERM1
      this.checkTerm2 = this.member.CONDITION_TERM2
      if (this.checkTerm1 !== null) {
        this.checkTerm1 = this.member.CONDITION_TERM1.toLowerCase() === 'true'
      }
      if (this.checkTerm2 !== null) {
        this.checkTerm2 = this.member.CONDITION_TERM2.toLowerCase() === 'true'
      }
      await this.getOnlyShop()
      await this.getLevelDB()
      this.level.sort((a, b) => {
        return b.point - a.point
      })
      this.level.map(row => {
        if (this.member.collectPoint < row.point) {
          this.nextlevel = row
        }
      })
      if (this.nextlevel) {
        this.point = this.nextlevel.point
      } else {
      }
      this.level = this.level.filter(
        item => parseInt(item.levelId) === parseInt(this.member.levelId)
      )[0]
      if (this.nextlevel && this.member.collectPoint > 0) {
        this.valueInprogress = (
          (this.member.collectPoint * 100) /
          this.nextlevel.point
        ).toFixed(2)
      }
    },
    openPrivacyNotice () {
      window.open(window.location.origin + '/PrivacyNotice', '_blank').focus()
    },
    async getHistory () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/lineHistory/get?redeemStatus=use'
      )
      if (result) {
        if (Array.isArray(result)) {
          this.rewardHistory = result
        }
      }
      this.dialogRewardhistory = true
    },
    async getMyReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/rewardCode/line/get?redeemStatus=get`
      )
      if (Array.isArray(result)) {
        this.rewards = result
      }
    },
    async upDatePDPA () {
      await this.callBeTaskAPI('post', `/member/edit/${this.member.memberId}`, {
        CONDITION_TERM1: this.checkTerm1,
        CONDITION_TERM2: this.checkTerm2
      })
      this.getMemberProfile()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          this.level = result
          this.allLevel = result
          return result
        }
      }
    },
    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.shopname = result[0].name
        }
      }
    },
    async getExpireDate () {
      const d = new Date()
      let ThisYear = d.getFullYear()
      let Nextyear = d.getFullYear() + 1
      const result2 = []
      const result3 = []
      const result = await this.callBeTaskAPI(
        'get',
        `/get-expired-date/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.expire = result
          .map(item => {
            return {
              expire: moment.unix(item.expireDate).format('MM/YYYY'),
              balanceExpire: item.balancePoint,
              year: moment.unix(item.expireDate).format('YYYY')
            }
          })
          .filter(item => {
            return item.year === ThisYear.toString()
          })

        this.expire1 = result
          .map(item => {
            return {
              expire: moment.unix(item.expireDate).format('MM/YYYY'),
              balanceExpire: item.balancePoint,
              year: moment.unix(item.expireDate).format('YYYY')
            }
          })
          .filter(item => {
            return item.year === Nextyear.toString()
          })
      }
      if (this.expire) {
        this.expire.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result2.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      if (this.expire1) {
        this.expire1.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result3.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      this.AllExpireCoinThisYear = result2.reduce(
        (accum, obj) => accum + obj.balanceExpire,
        0
      )
      this.AllExpireCoinNextYear = result3.reduce(
        (accum, obj) => accum + obj.balanceExpire,
        0
      )
      for (const element of this.month) {
        for (const a of result2) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
      for (const element of this.month1) {
        for (const a of result3) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
    },
    async getPackLog () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/get?userId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackage = true
      }
    },
    async getPackage () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/getCount?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackageCount = result[0].count
      }
    }
  }
}
</script>
<style scoped>
.card {
  height: 200px;
  overflow: hidden;
}

.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}

.v-progress-linear {
  width: 90%;
}

.test {
  padding-left: 20px;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
}

.text-gradient {
  background: linear-gradient(to right, #000000, #52057b, #892cdc, #bc6ff1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-bottom: 15px;
}
.back-forward {
 position: absolute;
 width: fit-content;
 height: 30px;
 margin: 10px 10px 10px 10px;
 display: flex;
 filter: drop-shadow(0px 1px 3px #ddd);
 background-color: #dddddd75;
 color:#555555;
 border-radius: 30px;
 display: flex;
 -webkit-box-pack: center;
 -webkit-box-align: center;
 align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/HeaderCard.vue